import React from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';

const WorkingThroughConflictFinalThoughts = () => (
  <div className="space-y-8">
    <PlaybookSection title="Final Thoughts" icon={<PencilSquareIcon className="h-7 w-7 text-primary-light" />} heading>
      <PlaybookCard>
        <div className="space-y-6">
          <p className="text-lg text-gray-300">
            Conflict happens, especially in high pressure environments like startups. These scenario based toolkits shared in this playbook can help you navigate your way through it and move from unhealthy → healthy conflict.
          </p>
          <p className="text-lg text-gray-300">
            Sometimes though, you will just inevitably come up against an asshole.
          </p>
          <p className="text-lg text-gray-300">
            If you do encounter someone like that: someone who just flat out refuses to even come to the table, is aggressive or violent and continues to relentlessly focus on self-interest vs what's good for the company then you have a few options: you either escalate the issue, recommend they are removed, avoid them, or leave. Nothing is worth your mental health.
          </p>
          <p className="text-lg text-gray-300">
            I hope that doesn't happen to you.
          </p>
        </div>
      </PlaybookCard>

      
    </PlaybookSection>
  </div>
);

export default WorkingThroughConflictFinalThoughts; 